import { EquipmentTemplate } from "@/common/api.service"
import { FETCH_EQUIPMENT_TEMPLATE_DATA, DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT, FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, ADD_EQUIPMENT_TEMPLATE_DATA, UPDATE_EQUIPMENT_TEMPLATE_DATA, DELETE_EQUIPMENT_TEMPLATE_DATA, RESET_STATE } from "./actions.type"
import { SET_EQUIPMENT_TEMPLATE_DATA, SET_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, SET_ERROR_EQUIPMENT_TEMPLATE, STATE_RESET  } from "./mutations.type"

const initialState = () => {
    return {
        equipmenttemplatedata: [],
        individualequipmenttemplate: {},
        equipmenttemplateerrors: null,
    }
}

let state = initialState()

const getters = {
    equipmenttemplatedata(state) {
        return state.equipmenttemplatedata
    },
    individualequipmenttemplate(state) {
        return state.individualequipmenttemplate
    }
}

const actions = {
    async [FETCH_EQUIPMENT_TEMPLATE_DATA](context, slug) {
        const { data } = await EquipmentTemplate.get(slug)
        context.commit(SET_EQUIPMENT_TEMPLATE_DATA, data.data)
        return data;
    },
    async [FETCH_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA](context, slug) {
        const { data } = await EquipmentTemplate.get(slug)
        context.commit(SET_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA, data.data)
        return data;
    },  
    async [ADD_EQUIPMENT_TEMPLATE_DATA](context, payload) {
        return await EquipmentTemplate.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_TEMPLATE, error.response.data.errors)
        });
    },   
    async [DOWNLOAD_EQUIPMENT_TEMPLATE_DOCUMENT](context, payload) {
        return await EquipmentTemplate.downloadFile(payload)
          .then(({data}) => {
            return data
          })
          .catch(error => {
            context.commit(SET_ERROR_EQUIPMENT_TEMPLATE, (error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message));
          });
    },    
    async [UPDATE_EQUIPMENT_TEMPLATE_DATA](context, payload) {
        return await EquipmentTemplate.update(payload, (payload.get('temp_id')?payload.get('temp_id'):'' ))
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_TEMPLATE, error.response.data.errors)
        });
    },  
    async [DELETE_EQUIPMENT_TEMPLATE_DATA] (context, id) {
        return await EquipmentTemplate.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT_TEMPLATE, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_EQUIPMENT_TEMPLATE](state, error) {
        state.equipmentgrouperrors = error
    },      
    [SET_EQUIPMENT_TEMPLATE_DATA](state, equipmenttemplatedata) {
        state.equipmenttemplatedata = equipmenttemplatedata
    },
    [SET_EQUIPMENT_TEMPLATE_INDIVIDUAL_DATA](state, individualequipmenttemplate) {
        state.individualequipmenttemplate = individualequipmenttemplate
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};